// material
import { createStyles } from "@material-ui/core";

export const styles = () =>
  createStyles({
    root: {
      paddingLeft: 15,
      paddingRight: 15
    },
    buildingInfo: {
      fontFamily: "HiraginoSans-W3",
      fontWeight: "normal",
      fontSize: 16,
      textAlign: "left",
      color: "#1f1f1f",
      width: 345,
      marginTop: 23
    },
    erorInfo: {
      fontWeight: "normal",
      fontSize: 16,
      textAlign: "left",
      color: "#F55D5D",
      width: 345
    },
    erorPhone: {
      color: '#F55D5D'
    },
    textInfo: {
      margin: 0,
      fontSize: 15
    },
    firstBooking: {
      width: 345,
      height: 100,
      fontSize: 24,
      lineHeight: "24px",
      marginTop: 22
    },
    changeBooking: {
      width: 345,
      height: 100,
      fontSize: 24,
      lineHeight: "24px",
      marginTop: 24
    },
    boxContact: {
      fontFamily: "HiraginoSans-W4",
      fontWeight: "normal",
      textAlign: "left",
      color: "#1f1f1f",
      width: 345,
      height: 64,
      marginTop: 33
    },
    boxContact2: {
      fontFamily: "HiraginoSans-W4",
      fontWeight: "normal",
      textAlign: "left",
      color: "#1f1f1f",
      marginTop: 33
    },
    textContact: {
      fontSize: 18,
      lineHeight: "32px",
      margin: 0
    },
    textPhone: {
      color: "#0256A8"
    },
    displayMobile: {
      display: "flex",
      justifyContent: "center"
    }
  });
